export default "__VITE_ASSET__E61tUUy4__"